import React from 'react';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import { selectIsOptionalById } from '../_redux';
import { SvgInputRemoveSelection } from './SvgInputRemoveSelection';
import { WebsiteState } from '@gift/website-state/store';
import { publicAssets } from '@gift/website-state/apis/publicAssets';
import { Grid } from '@gift/ui/components/grid/Grid';
import { Cell } from '@gift/ui/components/grid/Cell';
import { Card } from '@gift/ui/components/card/Card';
import { AspectRatio } from '@gift/ui/components/aspect-ratio/AspectRatio';
import { Spinner } from '@gift/ui/components/loaders/spinner/Spinner';
import { forWeb } from '@gift/common/helpers/assetUrlHelpers';
import styles from './SvgInputOptionGrid.module.scss';

export const _SvgInputOptionGrid = ({
    variableIds, collectionId,
    selectedAssetUrl, isOptional, onClick
}: Props) => {

    const urls = publicAssets.useGetCollectionUrlsQuery(collectionId);

    return (
        <Grid gap='s' xs='1/4' sm='1/5' wrap>

            {isOptional && (
                <Cell>
                    <SvgInputRemoveSelection
                        variableIds={variableIds}
                        active={!urls.isLoading && !selectedAssetUrl} />
                </Cell>
            )}

            {urls.isLoading && (
                <Cell>
                    <Card onClick={noop}>
                        <AspectRatio>
                            <Spinner overlaySize='full' spinnerSize='small' />
                        </AspectRatio>
                    </Card>
                </Cell>
            )}

            {urls.isSuccess && urls.data?.map(url => (
                <Cell key={url}>
                    <Card onClick={() => onClick(url)} active={url === selectedAssetUrl}>
                        <img
                            crossOrigin='anonymous'
                            width={300} height={300}
                            src={forWeb(url, { w: 300, h: 300 })}
                            className={styles.image} alt='' />
                    </Card>
                </Cell>
            ))}
        </Grid>
    );
};

type Props = {
    variableIds: string[],
    collectionId: string,
    selectedAssetUrl: string,
    isOptional: boolean,
    onClick: (url: string) => void
};

const mapStateToProps = (state: WebsiteState, ownProps: { variableIds: string[] }) => ({
    isOptional: selectIsOptionalById(state, ownProps.variableIds[0])!
});

export const SvgInputOptionGrid = connect(
    mapStateToProps
)(_SvgInputOptionGrid);
